<template>
  <v-card
    v-if="project"
    flat
    class="pa-3 d-flex"
    :to="'/processes/onboarding/' + onboarding.id"
    ><div>
      <v-progress-circular
        :model-value="(onboarding.activeStep / 7) * 100"
        :size="80"
        :width="8"
        color="primary"
      >
        <template v-slot:default>
          <template v-if="onboarding.activeStep >= 7">
            <v-icon>mdi-check</v-icon>
          </template>
          <template v-else> {{ onboarding.activeStep }}/7 </template>
        </template>
      </v-progress-circular>
    </div>
    <div>
      <v-card-title class="text-h5 text-capitalize my-0 py-0">{{
        project.name
      }}</v-card-title>
      <v-card-subtitle class="mt-2" style="font-size: 0.7rem"
        >ID {{ onboarding.id }}</v-card-subtitle
      >
    </div>
  </v-card>
</template>

<script>
import ApiService from "@/services/api.service";
import { NotifiyClient } from "@/models/notification";
export default {
  name: "OnboardingItem",
  props: {
    onboarding: Object,
    admin: Boolean,
  },
  data() {
    return {
      project: null,
    };
  },

  async created() {
    await this.getProjectOfInstance();
    // await this.getOnboardingofInstance();
  },
  methods: {
    deleteOnboarding() {
      let self = this;
      ApiService.post("onboarding/delete", { id: this.onboarding.id }).then(
        (response) => {
          if (response.data) {
            self.$store.dispatch(
              "notificationsStore/add",
              new NotifiyClient("success", "Erfolgreich gelöscht", false)
            );
          }
        }
      );
    },
    // async getOnboardingofInstance() {
    //   try {
    //     const response = await ApiService.get("onboarding/my/get");
    //     console.log("Response", response.data);
    //     this.onboarding = response.data.map;
    //     await this.getProjectOfInstance();
    //     console.log("Project", this.project);
    //   } catch (error) {
    //     console.log("Error", error);
    //   }
    // },
    async getProjectOfInstance() {
      console.log("Instance ID", this.onboarding.id);
      try {
        const response = await ApiService.post("onboarding/project/get", {
          id: this.onboarding.id,
        });
        this.project = response.data;
      } catch (error) {
        console.log("Error", error);
      }
    },
  },
};
</script>

<style scoped></style>
